<template>
  <div class="grid-wrap">
    <div class="grid-row">
      <article class="grid-col grid-col--soft grid-xsmall-12 grid-large-9 push__bottom">
        <Panel :title="title" variant="success" message />
        <div class="wysiwyg" v-html="content"></div>
        </article>
    </div>
  </div>
</template>

<script>
import { dataService } from '../shared';
export default {
  name: "Result",
  created() {},
  data() {
    return {
      title: "Thank you",
      content: "",
      age : 0,
      mainstream: 0,
      camhs: 0,
    };
  },
  mounted() {
    this.loadAnswer();
    this.checkAge();
  },
  methods: {
    async loadAnswer() {
      let responses = await dataService.getCompleteData();
      this.age = responses.Age;
      this.camhs = responses.Camhs;  
      this.mainstream = responses.Mainstream;
    },
    checkAge() {
      if(this.age >= 5 && this.age < 18 && this.mainstream != 'No' && this.camhs != 'Yes') { 
        if(this.age >= 8) { 
          // Multiple Questionaire
          this.content = "<p>Thank you for taking the time to complete these questionnaires. Your clinician will go through the results and discuss the outcome with you during your next appointment.</p>";
        } else {
          // Single Questionaire
          this.content = "<p>Thank you for taking the time to complete this questionnaire. Your clinician will go through the results and discuss the outcome with you during your next appointment.</p>";
        }
      } else {
        // Not Eligible
        this.content = "<p>Thank you for taking the time to complete this questionnaire. Your clinician will go through the results and discuss the outcome with you during your next appointment.</p>";
      }
    }
  }
};
</script>